import { render, staticRenderFns } from "./EdForm.vue?vue&type=template&id=0162a6e1&"
import script from "./EdForm.vue?vue&type=script&lang=js&"
export * from "./EdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports